const SESSION_TOKEN_KEY = 'guild_sessionToken';

export function getSessionToken() {
  try { return localStorage.getItem(SESSION_TOKEN_KEY) || ''; } catch { return ''; }
}

export function persistSessionToken(token: string) {
  try {
    if (token) localStorage.setItem(SESSION_TOKEN_KEY, token);
    else localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch {}
}

export function clearSessionToken() {
  persistSessionToken('');
}

